module.exports = "<div *ngIf=\"this.showMessage\" style=\"padding:50px;\" align=\"center\">\n  <h4>{{this.message}}</h4>\n</div>\n<div *ngIf=\"!this.showMessage\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/shared/no-records.component/nr.component.html
// module id = ./src/shared/no-records.component/nr.component.html
// module chunks = main